module.exports = __webpack_public_path__ + "media/src/images/drag_dark-bcbd5dcd913a387d84e46e3445fde885.png";